import StaticSearch from './Static';
import StickySearch from './Sticky';

export {
  StaticSearch,
  StickySearch,
};
